<header class="global-header">

  <div class="top-bar">
    <div class="top-inner">

      <div class="top-left">

        <!-- RSS -->
        <a
          href="https://www.social.gov.tn/fr/rss.xml"
          class="social-icon"
          target="_blank"
          aria-label="Flux RSS"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="white"
          >
            <circle cx="3" cy="17" r="2.5"/>
            <path
              d="M3 10 Q10 10 10 17"
              stroke="white"
              stroke-width="1.8"
              fill="none"
              stroke-linecap="round"
            />
            <path
              d="M3 4 Q16 4 16 17"
              stroke="white"
              stroke-width="1.8"
              fill="none"
              stroke-linecap="round"
            />
          </svg>
        </a>

        <!-- Instagram -->
        <a
          href="https://www.instagram.com/infos.social.tn/"
          class="social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="1.5"
          >
            <rect x="2" y="2" width="20" height="20" rx="6" ry="6"/>
            <circle cx="12" cy="12" r="5"/>
            <circle
              cx="17.5"
              cy="6.5"
              r="1.2"
              fill="white"
              stroke="none"
            />
          </svg>
        </a>

        <!-- YouTube -->
        <a
          href="https://www.youtube.com/channel/UCgvW0oBxJDzbTnK-q6s3Lcg"
          class="social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="1.5"
          >
            <rect x="2" y="4" width="20" height="16" rx="4"/>
            <polygon
              points="10,8 18,12 10,16"
              fill="white"
              stroke="none"
            />
          </svg>
        </a>

        <!-- Twitter / X -->
        <a
          href="https://x.com/tunisiesociale"
          class="social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            stroke="white"
            stroke-width="1.8"
            stroke-linecap="round"
          >
            <line x1="2" y1="2" x2="22" y2="22"/>
            <line x1="22" y1="2" x2="2" y2="22"/>
          </svg>
        </a>

        <!-- Facebook -->
        <a
          href="https://www.facebook.com/infos.social.tn/"
          class="social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="white"
          >
            <path
              d="M13 2 Q18 2 18 7 L18 11 L15 11 L15 22 L10 22 L10 11 L7 11 L7 7 L10 7 L10 5 Q10 2 13 2 Z"
            />
          </svg>
        </a>

        <!-- LinkedIn -->
        <a
          href="https://www.linkedin.com/company/tunisia-ministry-of-social-affairs/"
          class="social-icon"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="1.5"
          >
            <rect x="2" y="2" width="20" height="20" rx="4"/>
            <circle
              cx="7"
              cy="8"
              r="1.2"
              fill="white"
              stroke="none"
            />
            <line
              x1="7"
              y1="11"
              x2="7"
              y2="19"
              stroke-linecap="round"
            />
            <path
              d="M11 11 L11 19 M11 15 Q11 11 17 11 Q20 11 20 15 L20 19"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>

      </div>

      <div class="top-center">
        <span class="info-item">الرقم المبسط 1868</span>
        <span class="sep">|</span>
        <span class="info-item">الهاتف 000 150 71</span>
      </div>

      <div class="top-right">
        <img
          src="assets/images/flag-tn.svg"
          alt="Tunisie"
          class="flag-icon"
        />
      </div>

    </div>
  </div>

  <div class="white-bar">
    <div class="white-inner">

      <div class="brand">
        <img
          src="/assets/images/mas.png"
          alt="Platform"
          class="brand-logo"
        />
      </div>

      @if (!isLoggedIn) {

        <div class="btn-group">

          <a
            class="btn small primary"
            routerLink="/"
          >
            الصفحة الرئيسية
          </a>

          <a
            class="btn small outline"
            routerLink="/program-details"
          >
            مقاييس و شروط الخدمات
          </a>

          <a
            class="btn small outline"
            routerLink="/privacy-policy"
          >
            سياسة الخصوصية
          </a>

          <a
            class="btn small outline"
            href="https://www.social.gov.tn/ar/form/suggestions-et-reclamations"
            target="_blank"
            rel="noopener noreferrer"
          >
            اتصل بنا
          </a>

        </div>

      }

      @if (isLoggedIn) {

        <div class="btn-group-loggedin">

          <a
            class="btn small primary"
            routerLink="/pages/dashboard"
          >
            قائمة البرامج
          </a>

          <button
            class="btn-logout"
            type="button"
            (click)="veriflogout()"
            title="تسجيل الخروج"
            aria-label="تسجيل الخروج"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>

        </div>

        @if (showLogoutModal) {

          <div class="custom-modal-backdrop">

            <div
              class="custom-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="logout-title"
            >

              <div class="modal-body">
                <p id="logout-title">
                  هل أنت متأكد أنك تريد تسجيل الخروج؟
                </p>
              </div>

              <div class="modal-footer">

                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="logout()"
                >
                  تأكيد
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="cancelLogout()"
                >
                  إلغاء
                </button>

              </div>

            </div>

          </div>

        }

      }

      <div class="white-right"></div>

    </div>
  </div>

</header>
